import { DeleteButton, EditButton, ViewButton } from "@/components/IconButton/variants";

export default function Actions({ row, handleOnClickDelete }) {
  return (
    <div className="w-auto justify-center flex gap-x-1 ">
      <EditButton
        onClick={() => {
          console.log("EDIT BUTTON CLICKED");
        }}
      />
      <ViewButton
        onClick={() => {
          console.log("VIEW BUTTON CLICKED");
        }}
      />
      <DeleteButton
        onClick={() => {
          handleOnClickDelete(row.original);
        }}
      />
    </div>
  );
}
